
import { Component } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ServiceProgressComponent } from "../../../../../shared/components/service-progress/service-progress.component";
import { SHARED_COMPONENTS } from '../../../../../shared/shared-imports';
import { Location } from '@angular/common';

@Component({
  selector: 'app-ata-terms-conditions',
  imports: [TranslateModule, ...SHARED_COMPONENTS],
  templateUrl: './ata-terms-conditions.component.html',
  styleUrl: './ata-terms-conditions.component.scss'
})
export class AtaTermsConditionsComponent {
  formProgress: number = 30;

  // This method is used to initialize the class instance using location and translate
  constructor(
    private location: Location,
    private translate: TranslateService,
  ) {

  }
  // This method is used to check whether translation using section and idx
  hasTranslation(section: string, idx: number): boolean {
    const key = `TERMS.${section}.ITEM${idx}`;
    return this.translate.instant(key) !== key;   // key == value ⇒ not translated
  }

  // This method is used to back
  back() {
    // let path = `/${RoutesPath.SERVICE}/ata-carnet`;
    // this.router.navigate([path])
     this.location.back();
  }

}


